import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { premiumFontCss } from '@root/entities/premium/ui'
import { useTranslation } from '@root/shared/localization'
import { PremiumDialog } from '@root/shared/ui/premium-dialog'

import { ExtendPremium } from '../common/extend-premium'

import type { CurrencyModel } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium'
import type { ClassNameProps } from '@root/shared/react'
import type { DialogControlProps } from '@root/shared/ui-kit'

type ExtendPremiumDialogProps = {
  currency: CurrencyModel
  premium: PremiumMetaModel
} & ClassNameProps &
  DialogControlProps

export const ExtendPremiumDialog: React.FC<ExtendPremiumDialogProps> = ({
  className,
  currency,
  premium,
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation()
  return (
    <PremiumDialog
      open={open}
      onOpenChange={onOpenChange}
      title={
        <span>
          <Trans
            i18nKey={'premium.extend.title'}
            components={[<StyledTitle key={0} />]}
          />
        </span>
      }
      describedBy={t('premium.extend.title')}
      onClose={() => {
        onOpenChange?.(false)
      }}
      className={className}
    >
      <ExtendPremium
        onClose={() => {
          onOpenChange?.(false)
        }}
        currency={currency}
        premium={premium}
        device="desktop"
      />
    </PremiumDialog>
  )
}

const StyledTitle = styled.span`
  ${premiumFontCss}
  font-size: 18px;
`
